const esESMessages: Record<string, string> = {
  'error-loading-page.text': 'Parece que no podemos cargar esta sección. Lo sentimos, ¿puede intentarlo de nuevo?',
  'error-loading-page.button': 'Intentar de nuevo',
  'shared.something-went-wrong-message': '¡Uy!{br}¡Algo ha salido mal!',
  'shared.something-went-wrong-description':
    'No encontramos ese enlace en la aplicación.{br}Por favor, compruebe si hay algún error tipográfico o vuelva al panel de control de la campaña.',
};

export default esESMessages;
